/**
 * @generated SignedSource<<9939641c1f6025af8e2c1239210adabd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type QuoteProviderMarkBookNowPressedMutation$variables = {
  quoteId: string;
};
export type QuoteProviderMarkBookNowPressedMutation$data = {
  readonly markBookNowPressed: {
    readonly bookNowPressedAt: any | null;
    readonly id: string;
  } | null;
};
export type QuoteProviderMarkBookNowPressedMutation = {
  response: QuoteProviderMarkBookNowPressedMutation$data;
  variables: QuoteProviderMarkBookNowPressedMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "quoteId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "quoteId",
        "variableName": "quoteId"
      }
    ],
    "concreteType": "Quote",
    "kind": "LinkedField",
    "name": "markBookNowPressed",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "bookNowPressedAt",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "QuoteProviderMarkBookNowPressedMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "QuoteProviderMarkBookNowPressedMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "2ddd971e0a65b35f90fd54659b2804a2",
    "id": null,
    "metadata": {},
    "name": "QuoteProviderMarkBookNowPressedMutation",
    "operationKind": "mutation",
    "text": "mutation QuoteProviderMarkBookNowPressedMutation(\n  $quoteId: ID!\n) {\n  markBookNowPressed(quoteId: $quoteId) {\n    id\n    bookNowPressedAt\n  }\n}\n"
  }
};
})();

(node as any).hash = "6fa6029130d0344a4e76595a895a7ebd";

export default node;
